import { render, staticRenderFns } from "./ProjectTemplates.vue?vue&type=template&id=45fb02b3&scoped=true&"
import script from "./ProjectTemplates.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplates.vue?vue&type=style&index=0&id=45fb02b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb02b3",
  null
  
)

export default component.exports